<template>
  <div class="filter-pills" v-if="modelValue.length > 0">
    <span class="filter-clear" @click="clearFilter">Clear All {{ modelValue.length }} Filters</span>
    <q-chip
      class="pill"
      icon-remove="close"
      outline
      removable
      remove-aria-label="remove-pill"
      v-for="(pillVal, index) in modelValue"
      :key="`pill-${pillVal}-${index}`"
      v-model="pills[index]"
      @remove="onRemove"
      color="apg-med-grey"
      text-color="white"
    >
      {{ pillVal.label }}
    </q-chip>
  </div>
  <div v-else class="filter-pills"><b>No Filters Applied</b></div>
</template>

<script setup>
import { defineProps, defineEmits, ref, onBeforeMount } from 'vue';

const pills = ref([]);
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => {
      [];
    },
    required: true,
  },
  labelKey: {
    type: String,
    default: null,
  },
});
onBeforeMount(() => {
  pills.value = Array(props.modelValue.length).fill(true);
});

const emit = defineEmits(['update:modelValue', 'remove']);

function clearFilter() {
  pills.value = [];
  props.modelValue.forEach(item => {
    emit('remove', item)
  })
  emit('update:modelValue', []);
}

function onRemove() {
  const newArray = [...props.modelValue];
  let pillIndex = pills.value.indexOf(false);
  emit('remove', newArray[pillIndex])
  newArray.splice(pillIndex, 1);
  pills.value.splice(pillIndex, 1);
  emit('update:modelValue', newArray);
}
</script>

<style lang="scss" scoped>
.filter-clear {
  color: $apg-dark-blue;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  margin-right: 4px;
}
.q-chip {
  letter-spacing: 0.4px;
  font-size: 12px;
  line-height: 16px;
}
.filter-pills {
  padding: 20px 0;

  b {
    letter-spacing: 0.4px;
    line-height: 32px;
  }
  &::v-deep {
    .q-chip__icon--remove {
      font-size: 12px;
      margin-left: 8px;
    }
  }
}
.h-10 {
  height: 10px;
}
</style>
